import "./lib/sentry";
import { createRoot } from "react-dom/client";
import { ErrorBoundary } from "@sentry/react";
import App from "./App.tsx";
import "./index.css";

createRoot(document.getElementById("root")!).render(
    <ErrorBoundary fallback={<div className="p-4">An error has occurred.</div>}>
        <App />
    </ErrorBoundary>
);
